import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';
import { ContactDTO } from '@/models/ContactDto';

export interface FilterContacts {
    siteId?: number,
    recherche?: string,
}

class ContactService {

    public async getInterlocuteurs(adresseSiteId: number): Promise<any> {
        return http.get(Routes.ContactRoutes.GetInterlocuteurs(adresseSiteId));
    }

    public async sendMessage(contact: ContactDTO): Promise<any> {
        return http.post(Routes.ContactRoutes.SendMessage(), contact);
    }

    public async getExportXlsContacts(params: FilterContacts): Promise<any> {
        if (params.siteId === undefined) {
            if(params.recherche !== '') {
                return http.get(Routes.ContactRoutes.GetExportXlsFilteredContacts(), {params, responseType: 'arraybuffer'});
            }
            return http.get(Routes.ContactRoutes.GetExportXlsAllContacts(), { responseType: 'arraybuffer'});
        } else {
            return http.get(Routes.ContactRoutes.GetExportXlsContacts(params.siteId), { responseType: 'arraybuffer' });
        }
    }

}

export default new ContactService();
